import { render, staticRenderFns } from "./ScrollTop2.vue?vue&type=template&id=680cfa60&"
import script from "./ScrollTop2.vue?vue&type=script&lang=js&"
export * from "./ScrollTop2.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTop2.vue?vue&type=style&index=0&id=680cfa60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports